export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILED = "LOGIN_FAILED"


export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAILED = "GET_USER_PROFILE_FAILED"

export const LOGOUT = "LOGOUT"

